__turbopack_context__.v({
  "checkboxWrapper": "SHNWUG_checkboxWrapper",
  "optionWrapper": "SHNWUG_optionWrapper",
  "text": "SHNWUG_text",
  "trailing": "SHNWUG_trailing",
  "wrapper": "SHNWUG_wrapper",
});
